// These configurations correlate to the BoughtThisSeasonProvider documented
// here https://epicuro.atlassian.net/wiki/spaces/PD/pages/3815636994/Best+performing+articles+provider
import {
  AvailableProductsProcessorProperties,
  SearchSortType,
} from './available-products-processor-properties.models';

export type OrderTypeType = 'now' | 'future';

export enum BoughtThisSeasonProviderConfigArgsProperties {
  productsAmount = 'productsAmount',
  fromDate = 'fromDate',
  toDate = 'toDate',
  numberOfDaysFrom = 'numberOfDaysFrom',
  numberOfDaysTo = 'numberOfDaysTo',
  filterMissingImages = 'filterMissingImages',
  loadPrices = 'loadPrices',
  isDelivered = 'isDelivered',
  isGlobalNoos = 'isGlobalNoos',
  searchSortType = 'searchSortType',
  type = 'type',
  orderType = 'orderType',
  collapse = 'collapse',
  productLevel = 'productLevel',
  dateRangeField = 'dateRangeField',
  aggregationType = 'aggregationType',
  category = 'category',
  sortDirection = 'sortDirection',
}

export type BoughtThisSeasonProviderConfigArgs = {
  [BoughtThisSeasonProviderConfigArgsProperties.fromDate]: string;
  [BoughtThisSeasonProviderConfigArgsProperties.toDate]: string;
  [BoughtThisSeasonProviderConfigArgsProperties.numberOfDaysFrom]: number;
  [BoughtThisSeasonProviderConfigArgsProperties.numberOfDaysTo]: number;
  [BoughtThisSeasonProviderConfigArgsProperties.productsAmount]: number;
  [BoughtThisSeasonProviderConfigArgsProperties.filterMissingImages]: boolean;
  [BoughtThisSeasonProviderConfigArgsProperties.loadPrices]: boolean;
  [BoughtThisSeasonProviderConfigArgsProperties.isDelivered]?: boolean;
  [BoughtThisSeasonProviderConfigArgsProperties.isGlobalNoos]?: boolean;
  [BoughtThisSeasonProviderConfigArgsProperties.searchSortType]?: SearchSortType;
  [BoughtThisSeasonProviderConfigArgsProperties.type]?: OrderTypeType;

  [BoughtThisSeasonProviderConfigArgsProperties.orderType]?: number;
  [BoughtThisSeasonProviderConfigArgsProperties.collapse]?: boolean;
  [BoughtThisSeasonProviderConfigArgsProperties.productLevel]?: number;
  [BoughtThisSeasonProviderConfigArgsProperties.dateRangeField]?: number;
  [BoughtThisSeasonProviderConfigArgsProperties.aggregationType]?: number;
  [BoughtThisSeasonProviderConfigArgsProperties.category]?: string;
  [BoughtThisSeasonProviderConfigArgsProperties.sortDirection]?: number;
};

export enum AggregationType {
  CardinalityOrderId = 0,
  SumRequestedSizeQuantity = 1,
  SumConsolidatedNetPriceTotal = 2,
}

export enum DateRangeField {
  DeliveryDate = 0,
  OrderDate = 1,
}

export type BoughtThisSeasonProviderArgs = {
  brandId: string;
  fromDate: string;
  toDate: string;
  productLevel?: number;
  addressId?: string;
  isGlobalNoos?: boolean;
  isDelivered?: boolean;
  orderType?: number;
  sortDirection?: number;
  category?: string;
  dateRangeField?: DateRangeField;
  aggregationType?: AggregationType;
  productsAmount?: number;
} & AvailableProductsProcessorProperties;
